import { TOrderStatus } from './order-status';

export interface OrderSearchRaw {
    orderId: number;
    orderUuid: string;
    contrId: number;
    userId: number;
    totalSum: number;
    status?: TOrderStatus;
    sumRange: number;
    date: Date | string;
    dateRange: number;
    pickupAddress: string;
    comment: string;
}

export class COrderSearch {
    public orderId: number;
    public orderUuid: string;
    public contrId: number;
    public userId: number;
    public totalSum: number;
    public status: TOrderStatus;
    public sumRange: number;
    public date: Date;
    public dateRange: number;
    public pickupAddress: string;
    public comment: string;

    constructor(data?: Partial<OrderSearchRaw>) {
        this.orderId = data?.orderId;
        this.orderUuid = data?.orderUuid;
        this.contrId = data?.contrId;
        this.userId = data?.userId;
        this.totalSum = data?.totalSum;
        this.status = data?.status;
        this.sumRange = data?.sumRange;
        this.dateRange = data?.dateRange;
        this.pickupAddress = data?.pickupAddress;
        this.comment = data?.comment;
        this.date = typeof data?.date === 'string' ? new Date(data.date) : (data?.date instanceof Date ? data.date : undefined);
    }
}
